<template>
	<el-dialog class="reportDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				群聊名称（1/2）
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="" prop="title">
					<el-input v-model="ruleForm.title" placeholder="请输入群聊名称" />
				</el-form-item>
				<el-form-item label="" prop="content">
					<el-input type="textarea" :rows="4" v-model="ruleForm.content" placeholder="请输入群聊简介" />
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium" @click="submitForm('ruleForm')">下一步</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => {},
			}
		},
		// watch: {
		// 	data: {
		// 		handler(newValue) {
		// 			console.log('测试',newValue)
		// 			this.ruleForm = {
		// 				...newValue
		// 			}
		// 		},
		// 		deep: true
		// 	}
		// },
		data() {
			return {
				ruleForm: {
					title: '',
					content: '',
				},
				rules: {
					title: [{
						required: true,
						message: '请输入群聊名称',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入群聊简介',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			handleClose() {
				this.ruleForm.title = ''
				this.ruleForm.content = ''
				this.$emit('close')
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// this.$api.post('/Hua/create_group', {
						// 	...this.ruleForm
						// }).then(res => {
						// 	if (res.code == 1) {
						// 		if (res.code == 1) {
						this.$emit('update', this.ruleForm)
						// 		} else {
						// 			this.$message.success(res.msg)
						// 		}
						// 	}
						// }).catch(err => {
						// 	console.log(err);
						// })
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 4.1rem;
									padding: .08rem .16rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									border: .01rem solid #EFD8B8;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>